import React from 'react';
import {curry} from 'ramda';
import {getContentAnchorEl} from '@pluto/utils';
import {
    Select,
    MenuItem,
    Checkbox,
    InputLabel,
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';

import {SelectChangeEvent} from '../../../QCManager/QCManagerTypes';

interface JiraIssueMultiSelectProps {
    placeholder: string;
    options: string[];
    values: string[];
    setValues: (values: string[]) => void;
}

export default function JiraIssueMultiSelect(props: JiraIssueMultiSelectProps) {
    const {
        placeholder,
        options,
        values,
        setValues,
    } = props;

    const handleChange = onHandleChange(setValues, options);
    const firstMenuItemValue = getMenuItemValue(values, options);

    return (
        <div className="dialog__additional-options">
            <FormControl variant="filled">
                <InputLabel id={placeholder}>
                    {placeholder}
                </InputLabel>
                <Select
                    labelId={placeholder}
                    multiple
                    value={values}
                    onChange={handleChange}
                    renderValue={renderSelectValue(options)}
                    MenuProps={{
                        getContentAnchorEl,
                    }}
                >
                    <MenuItem value={firstMenuItemValue}>
                        {getMenuItemLabel(values, options)}
                    </MenuItem>
                    {options.map(getMenuItemOption(isChecked, values))}
                </Select>
            </FormControl>
        </div>
    );
}

export const getMenuItemValue = (values: string[] | string, options: string[]) => {
    return values.length === options.length ? 'none' : 'all';
};

export const getMenuItemLabel = (values: string[] | string, options: string[]) => {
    return values.length === options.length ? 'Deselect all' : 'Select all';
};

export const mapSelectedOption = (option: string) => {
    return `${option}, `;
};

export const filterSelectedOption = curry((selectedValue: string[], option: string) => {
    return selectedValue.includes(option);
});

export const getSelectedOptions = (options: string[], selectedValue: string[]) => {
    return options
        .filter(filterSelectedOption(selectedValue))
        .map(mapSelectedOption);
};

export const renderSelectValue = curry((options: string[], selectValue: string[]) => (
    getSelectedOptions(options, selectValue)
));

export const getMenuItemOption = curry((isChecked, values, option) => (
    <MenuItem
        key={option}
        value={option}
    >
        <Checkbox
            checked={isChecked(values, option)}
        />
        {option}
    </MenuItem>
));

export const isChecked = (values: string[] | string, option: string): boolean => {
    return values.includes(option);
};

export const getNewValues = (newValues: string[], options: string[]): string[] => {
    if (!newValues || newValues.includes('none'))
        return [];

    if (newValues.includes('all'))
        return options;

    return newValues;
};

export const onHandleChange = curry((setValues: (values: string[]) => void, options: string[], event: SelectChangeEvent) => {
    const newValues = getNewValues(event.target.value, options);

    setValues(newValues);
});
